/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminStockManageListResVo } from './AdminStockManageListResVo';
import {
    AdminStockManageListResVoFromJSON,
    AdminStockManageListResVoFromJSONTyped,
    AdminStockManageListResVoToJSON,
    AdminStockManageListResVoToJSONTyped,
} from './AdminStockManageListResVo';

/**
 * 
 * @export
 * @interface PageDataAdminStockManageListResVo
 */
export interface PageDataAdminStockManageListResVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataAdminStockManageListResVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataAdminStockManageListResVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataAdminStockManageListResVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<AdminStockManageListResVo>}
     * @memberof PageDataAdminStockManageListResVo
     */
    records?: Array<AdminStockManageListResVo>;
}

/**
 * Check if a given object implements the PageDataAdminStockManageListResVo interface.
 */
export function instanceOfPageDataAdminStockManageListResVo(value: object): value is PageDataAdminStockManageListResVo {
    return true;
}

export function PageDataAdminStockManageListResVoFromJSON(json: any): PageDataAdminStockManageListResVo {
    return PageDataAdminStockManageListResVoFromJSONTyped(json, false);
}

export function PageDataAdminStockManageListResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataAdminStockManageListResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(AdminStockManageListResVoFromJSON)),
    };
}

export function PageDataAdminStockManageListResVoToJSON(json: any): PageDataAdminStockManageListResVo {
    return PageDataAdminStockManageListResVoToJSONTyped(json, false);
}

export function PageDataAdminStockManageListResVoToJSONTyped(value?: PageDataAdminStockManageListResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(AdminStockManageListResVoToJSON)),
    };
}

